import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { navigation } from '../../data/navigation';
export function DesktopNav() {
  const [open, setOpen] = useState<string | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(null);
  }, [pathname]);
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(null);
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);
  return <div ref={wrapperRef} className="hidden lg:block" onMouseLeave={() => setOpen(null)} data-id="element-160" data-mp="2xtplstjopyy8">
      <nav aria-label="Primary" data-id="element-161" data-mp="w09xi3b2kw6f">
        <ul className="flex items-center gap-1" data-id="element-162" data-mp="w00383izs2ux">
          {navigation.map(section => {
          const active = pathname === section.href;
          const isOpen = open === section.label;
          if (!section.items) {
            return <li key={section.label} data-id="element-163" data-mp="u9upduacmqen">
                  <Link to={section.href} onMouseEnter={() => setOpen(null)} className={`label block px-3 py-3 transition-colors duration-150 ease-soft ${active ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-164" data-mp="pc2xh09pf4ag">
                    {section.label}
                  </Link>
                </li>;
          }
          return <li key={section.label} className="relative" data-id="element-165" data-mp="lbizxvl7xyns">
                <button type="button" aria-expanded={isOpen} aria-controls={`menu-${section.label.replace(/\s+/g, '-')}`} onMouseEnter={() => setOpen(section.label)} onClick={() => setOpen(isOpen ? null : section.label)} className={`label flex items-center gap-1.5 px-3 py-3 transition-colors duration-150 ease-soft ${isOpen || active ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-166" data-mp="ld3u3k3mffl4">
                  {section.label}
                  <ChevronDownIcon className={`h-3 w-3 transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-167" data-mp="28u0hdhtq4o46" />
                </button>

                {isOpen && <div id={`menu-${section.label.replace(/\s+/g, '-')}`} className="absolute left-0 top-full z-50 w-[340px] border border-line bg-paper shadow-paper" data-id="element-168" data-mp="1l46634p1z7m1">
                    <Link to={section.href} className="label block border-b border-line px-7 py-4 text-olive transition-colors duration-150 ease-soft hover:bg-white" data-id="element-169" data-mp="1uvansc6456kk">
                      {section.overviewLabel ?? section.label} →
                    </Link>

                    <ul className="px-7 py-5" data-id="element-170" data-mp="3bluobso806k6">
                      {section.items.map(item => <li key={item.label} data-id="element-171" data-mp="36m8bvlg7uucf">
                          <Link to={item.href} className="group flex items-baseline justify-between gap-4 py-2.5" data-id="element-172" data-mp="36kx8hmqonolu">
                            <span className="font-display text-[20px] font-300 leading-snug text-ink decoration-olive decoration-1 underline-offset-[5px] group-hover:underline" data-id="element-173" data-mp="2wpvgmj50w8fk">
                              {item.label}
                            </span>
                            {item.note && <span className="shrink-0 text-[11.5px] text-muted/70" data-id="element-174" data-mp="2iygw27vgvz6e">
                                {item.note}
                              </span>}
                          </Link>
                        </li>)}
                    </ul>

                    {section.feature && <Link to={section.feature.href} className="block border-t border-line bg-white px-7 py-5 transition-colors duration-150 ease-soft hover:bg-creme/50" data-id="element-175" data-mp="huep6neqf2yk">
                        <span className="label text-muted/70" data-id="element-176" data-mp="83acjucj3u6w">Featured</span>
                        <span className="mt-2 block font-display text-[21px] font-300 leading-snug text-ink" data-id="element-177" data-mp="3q9gctz6uout1">
                          {section.feature.label}
                        </span>
                        <span className="mt-1 block text-[12.5px] leading-relaxed text-muted" data-id="element-178" data-mp="3gd3kp5qyep0e">
                          {section.feature.blurb}
                        </span>
                      </Link>}
                  </div>}
              </li>;
        })}
        </ul>
      </nav>
    </div>;
}